import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex-fill text-truncate" }
const _hoisted_2 = { key: 0 }

import {ref} from 'vue';
import ObjectHelper from "~/ts/library/ObjectHelper";
import ServerSideConfigUsedWarning from "~/operatorApplication/vue/config/ServerSideConfigUsedWarning.vue";


import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Draggable from "~/node_modules/vuedraggable/src/vuedraggable.js";

const __default__ = {
    name: "OperatorBuddyListOrderConfig",
    components: {
        FontAwesomeIcon,
        Draggable
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    orderConfig: {},
    buddyListOrderFields: {},
    isServerSide: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let fields = ref<OperatorApplicationApi.OperatorBuddyListOrderFieldOpenApiModel[]>();
let value = ref<OperatorApplicationApi.OperatorBuddyListConfigOrderOpenApiModel[]>();

value.value = ObjectHelper.jsonClone(props.orderConfig);
makeFields();

function makeFields() {
    fields.value = [...props.buddyListOrderFields].sort((a, b) => {
        let aWeight = getWeightOfField(a.id);
        let bWeight = getWeightOfField(b.id);
        if (aWeight != bWeight) {
            if (aWeight == -1) {
                return 1;
            }
            if (bWeight == -1) {
                return -1;
            }
            return aWeight > bWeight ? 1 : -1;
        } else {
            return 0;
        }
    });
}

function toggleField(fieldId: string, flag: boolean) {
    let currentWeight = getWeightOfField(fieldId);
    if (!flag && currentWeight > -1) {
        value.value.splice(currentWeight, 1);
    }
    if (flag && currentWeight == -1) {
        value.value.push({
            fieldId,
            direction: 1
        });
    }
    makeFields();
    update();
}

function update() {
    emits("update", ObjectHelper.jsonClone(value.value));
}

function onSortEnd() {
    value.value = fields.value
        .filter(field => getWeightOfField(field.id) > -1)
        .map(field => ({
            fieldId: field.id,
            direction: value.value.find(item => item.fieldId == field.id).direction
        }));
    update();
}

function getWeightOfField(fieldId: string): number {
    return value.value.findIndex(item => fieldId == item.fieldId);
}

function getDirection(fieldId: string): number {
    let item = value.value.find(item => fieldId == item.fieldId);
    return item?.direction;
}

function toggleDirection(fieldId: string) {
    let item = value.value.find(item => fieldId == item.fieldId);
    item.direction = item.direction === 1 ? -1 : 1;
    update();
}

function f(field: any): OperatorApplicationApi.OperatorBuddyListOrderFieldOpenApiModel {
    return field;
}


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isServerSide)
      ? (_openBlock(), _createBlock(ServerSideConfigUsedWarning, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Draggable), {
      modelValue: _unref(fields),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fields) ? (fields).value = $event : fields = $event)),
      filter: ".disabled-field",
      "item-key": "id",
      onSort: onSortEnd
    }, {
      item: _withCtx(({element}) => [
        (_openBlock(), _createElementBlock("div", {
          key: f(element).id,
          class: _normalizeClass({
                    'mt-3': true,
                    'disabled-field': getWeightOfField(f(element).id) === -1 || __props.isServerSide,
                    'd-flex': true,
                    'align-items-center': true
                })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_switch, {
              "model-value": getWeightOfField(f(element).id) > -1,
              disabled: __props.isServerSide,
              class: "mr-2",
              "onUpdate:modelValue": ($event: any) => (toggleField(f(element).id, $event))
            }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]),
            _createTextVNode(" " + _toDisplayString(f(element).descr), 1)
          ]),
          (getWeightOfField(f(element).id) > -1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    class: "ml-2",
                    disabled: __props.isServerSide,
                    link: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, {
                        class: "cursor-pointer direction",
                        style: _normalizeStyle(getDirection(f(element).id) === -1 ? 'transform: rotateZ(180deg)': null),
                        icon: "long-arrow-down"
                      }, null, 8, ["style"])
                    ]),
                    _: 2
                  }, 1032, ["disabled"])), [
                    [_directive_on_native, () => toggleDirection(f(element).id), "click"]
                  ])
                ]),
                (!__props.isServerSide)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(FontAwesomeIcon, {
                        class: "cursor-move text-muted ml-2",
                        icon: "ellipsis-v"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 2))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})